import Vue from 'vue'

const randomizeColorsBus = new Vue()

export default randomizeColorsBus
